export default __webpack_public_path__ + "static/media/41.03179a95.jpg";